<template>
  <div class="row">
    <div class="mr-0 col-lg-2 col-xs-12 center">
      <inertia-link :href="`/recruiters/talent_banks/${talent_bank.id}/candidate/`">
        <img
          class="thumb-box mt-3 mb-2"
          style="border: none"
          :src="talent_bank.image ? talent_bank.image : '/images/avatar.png'"
        />
      </inertia-link>
    </div>
    <div class="col-lg-10 col-xs-12 mt-3 pt-2">
      <div class="mb-2">
        <span class="label-bold">
          <inertia-link :href="`/recruiters/talent_banks/${talent_bank.id}/candidate/`">
            {{ talent_bank.candidate_name }}
          </inertia-link>
        </span>
      </div>

      <div>
        <span>
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : talent_bank.experiences[0].occupation.name
            }}
        </span>
        <span class="text-lower">
          {{ checkData(talent_bank.experiences[0]) == false ? "" : "em" }}
        </span>
        <span class="label-bold color-dark-purple">
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : talent_bank.experiences[0].company.name
            }}
        </span>
      </div>
      <div>
        <span>
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : format(
                    new Date(talent_bank.experiences[0].start_work),
                    "MM/dd/yyyy"
                  )
            }}
        </span>
        <span
          class="text-lower"
          v-if="!showEndWork"
        >
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : verifyCurrentJob(talent_bank.experiences[0])
            }}
        </span>
        <span
          class="text-lower"
          v-if="showEndWork"
        >
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : verifyCurrentJob(talent_bank.experiences[0])
            }}
        </span>
        <span style="font-size: 14px; color: grey">
          {{
              checkData(talent_bank.experiences[0]) == false
                ? ""
                : "(" + showExperienceTiming(talent_bank.experiences[0]) + ")"
            }}
        </span>
      </div>
      <div>
        <p
          v-if="talent_bank.skills_names"
          class='color-grey mt-0 mb-0 text-truncate '
        >Habilidades técnicas: {{talent_bank.skills_names}}</p>
        <p
          v-if="talent_bank.study_areas_names"
          class='color-grey text-truncate '
        >Educação: {{talent_bank.study_areas_names}}</p>
      </div>
      <div>
        <span
          class="pt-2"
          v-if="
              nullOrVoid(talent_bank.city_name) ||
              nullOrVoid(talent_bank.state_name) != ''
            "
        >
          <i class="fas fa-map-marker-alt color-dark-purple"></i>
          {{ nullOrVoid(talent_bank.city_name) }}
          {{ nullOrVoid(talent_bank.state_name) }}
        </span>
      </div>

      <div
        class="extended-infos mt-2 mb-3 pointer"
        v-if="talent_bank.experiences.length > 1"
      >
        <div>
          <div
            @click="showMoreInfo = !showMoreInfo"
            class="center pointer d-flex"
          >
            <div class="icon-see-more">
              <i class="fas fa-chevron-circle-down color-dark-purple"></i>
            </div>
            <span> VER {{ showMoreInfo ? 'MENOS' : 'MAIS'}}</span>
          </div>
        </div>

        <div
          class="row"
          v-if="showMoreInfo"
        >
          <div class="col-lg-12 col-xs-12 mt-3">
            <span class="label-bold">HISTÓRICO PROFISSIONAL</span>
          </div>
          <div
            class="col-lg-12 col-xs-12 mb-2 mt-1"
            v-for="(experience, index) in talent_bank.experiences"
            :key="experience.id"
          >
            <div v-if="index > 0">
              <div>
                <span>
                  {{ experience.occupation.name }}
                </span>
                <span class="text-lower"> em </span>
                <span class="label-bold color-dark-purple">{{
                    experience.company.name
                  }}</span>
              </div>
              <div>
                <span>
                  {{ format(new Date(experience.start_work), "MM/dd/yyyy") }}
                </span>
                <span class="text-lower"> até </span>
                <span>
                  {{ verifyCurrentJob(experience) }}
                </span>
                <span style="font-size: 14px; color: grey">
                  {{ "(" + showExperienceTiming(experience) + ")" }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDistanceStrict, formatDistance, format } from "date-fns";
import { ptBR } from "date-fns/locale";

export default {
  props: ["talent_bank"],
  data: () => ({
    formatDistanceStrict: formatDistanceStrict,
    formatDistance: formatDistance,
    format: format,
    ptBR: ptBR,
    gender: [
      "Homen",
      "Mulher",
      "Transgêneros",
      "Não identificado",
      "Não cadastrado",
    ],
    showEndWork: false,
    showMoreInfo: false,
    openInfo: "",
  }),
  methods: {
    nullOrVoid(item) {
      if (item == "" || item == null) {
        return "";
      }

      return item;
    },
    showExperienceTiming(item) {
      let date = new Date();
      if (item.end_work == null) {
        date = formatDistanceStrict(new Date(item.start_work), new Date(), {
          locale: ptBR,
        });
        return date;
      }

      date = formatDistanceStrict(
        new Date(item.start_work),
        new Date(item.end_work),
        { locale: ptBR }
      );
      return date;
    },
    checkData(item) {
      return item ? item : false;
    },
    verifyCurrentJob(item) {
      let data = this.checkData(item);

      if (data.current_job == true) {
        this.showEndWork = false;
        return "até o momento";
      }

      return "até " + format(new Date(data.end_work), "MM/dd/yyyy");
    },
    showField(field, monetary = false) {
      if (field == null || "" || field.length == 0 || field == 0) {
        return "Não Informado";
      }
      return monetary ? this.formatCurrency(field) : field;
    },
  },
};
</script>

<style>
</style>